export enum AmenityV2Enum {
  'bathtub' = 'Bath Tub',
  'shampoo' = 'Shampoo',
  'essentials' = 'Essentials',
  'dryer' = 'Dryer',
  'hangers' = 'Hangers',
  'towels_provided' = 'Towels',
  'washer' = 'Washer',
  'cable_tv' = 'Cable TV',
  'tv' = 'TV',
  'stereo_system' = 'Stereo System',
  'air_conditioning' = 'Air Conditioning',
  'heating' = 'Heating',
  'indoor_fireplace' = 'Indoor Fireplace',
  'fire_extinguisher' = 'Fire Extinguisher',
  'first_aid_kit' = 'First Aid Kit',
  'smoke_detector' = 'Smoke Detector',
  'desk' = 'Desk',
  'wireless_internet' = 'Wireless Internet',
  'laptop_friendly_workspace' = 'Laptop Friendly Workspace',
  'coffee_maker' = 'Coffee Maker',
  'cookware' = 'Cookware',
  'dishes_and_silverware' = 'Dishes & Silverware',
  'dishwasher' = 'Dishwasher',
  'kitchen' = 'Kitchen',
  'kettle' = 'Kettle',
  'microwave' = 'Microwave',
  'oven' = 'Oven',
  'refrigerator' = 'Refrigerator',
  'stove' = 'Stove',
  'toaster' = 'Toaster',
  'private_pool' = 'Private Pool',
  'garden_or_backyard' = 'Garden or Backyard',
  'patio_or_balcony' = 'Patio or Balcony',
  'bbq_grill' = 'BBQ Grill',
  'ev_charger' = 'EV Charger',
  'free_parking_on_premises' = 'Free parking',
  'doorman' = 'Doorman',
  'tub_with_shower_bench' = 'Tub with shower bench',
  'elevator' = 'Elevator',
  'gym' = 'Gym or Fitness Center',
}
